<template>
  <div class="form-group">
    <select class="form-control" v-model="selected">
      <option v-for="saleOption in productOffer.sale_options" v-bind:value="saleOption.id">
        <sale-option v-bind:codename="saleOption.codename" v-bind:duration="saleOption.duration"/>
      </option>
    </select>
  </div>
</template>

<script>
import SaleOption from 'components/SaleOption'

export default{
  name: 'sale-option-select',
  props: ['productOffer'],
  data () {
    return {
      selected: null
    }
  },
  created () {
    this.selected = this.defaultSaleOption()
  },
  methods: {
    defaultSaleOption () {
      return this.productOffer.sale_options[0].id
    },
    notifySelected () {
      this.$emit('selected-sale-option', {
        productOfferID: this.productOffer.id,
        saleOptionID: this.selected
      })
    }
  },
  components: {
    SaleOption
  },
  watch: {
    'selected': 'notifySelected'
  }
}
</script>



// WEBPACK FOOTER //
// src/components/devices/SaleOptionSelect.vue